import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import './help.css'

// Small "i" beside a name; click for a one-paragraph explanation.
function InfoDot({ text, label = 'What is this?' }) {
  const [pos, setPos] = useState(null)
  const btnRef = useRef(null)
  const popRef = useRef(null)

  useEffect(() => {
    if (!pos) return undefined
    const close = (event) => {
      if (btnRef.current?.contains(event.target) || popRef.current?.contains(event.target)) return
      setPos(null)
    }
    const onKey = (event) => {
      if (event.key === 'Escape') setPos(null)
    }
    document.addEventListener('mousedown', close, true)
    document.addEventListener('keydown', onKey)
    window.addEventListener('resize', close)
    return () => {
      document.removeEventListener('mousedown', close, true)
      document.removeEventListener('keydown', onKey)
      window.removeEventListener('resize', close)
    }
  }, [pos])

  const toggle = () => {
    if (pos) return setPos(null)
    const rect = btnRef.current.getBoundingClientRect()
    const width = 260
    setPos({
      top: rect.bottom + 8,
      left: Math.max(8, Math.min(rect.left - 12, window.innerWidth - width - 8)),
    })
  }

  return (
    <span className="help-info">
      <button
        ref={btnRef}
        type="button"
        className="help-info-btn"
        aria-label={label}
        aria-expanded={Boolean(pos)}
        onClick={toggle}
      >
        i
      </button>
      {pos
        ? createPortal(
            <div ref={popRef} className="help-info-pop" role="tooltip" style={pos}>
              {text}
            </div>,
            document.body
          )
        : null}
    </span>
  )
}

export default InfoDot
